import type { FileAccessOption } from "@entrilia/shared/api/fileTypes";
import { isFileDownloadAllowed } from "@entrilia/shared/utilities/fileHelper";

export type DocumentAccessOption = "ViewAndDownload" | "ViewOnly";

export const formatDocumentAccess = (docAccess: DocumentAccessOption): string =>
  docAccess === "ViewAndDownload" ? "View & Download" : docAccess === "ViewOnly" ? "View" : "";

export const getDocumentAccessOption = (accessOptions: FileAccessOption[] | undefined): DocumentAccessOption =>
  isFileDownloadAllowed(accessOptions) ? "ViewAndDownload" : "ViewOnly";

export const getFileAccessOptions = (docAccess: DocumentAccessOption): FileAccessOption[] =>
  docAccess === "ViewAndDownload" ? ["View", "Download"] : ["View"];
